import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { Box, useTheme } from "@mui/material";
import { DataGridPro } from "@mui/x-data-grid-pro";
import { useNavigate } from "react-router-dom";
import { fetchPlaylists } from "../../../../store/Playlists/playlistsThunks";
import DetailPanel from "./DetailPanelContent"; // import the new panel
import PlaylistActionCell from "./PlaylistActionCell"; // import the new action cell
import { Modal } from '@mui/material';
function PlaylistDataGrid({ data, loading, apiRef }) {
  const theme = useTheme();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [rows, setRows] = useState([]);
  const [filterModel, setFilterModel] = useState({ items: [] });
  const [selectionModel, setSelectionModel] = useState([]);
  const [sortModel, setSortModel] = useState([]);
  const [openCreatePlaylist, setOpenCreatePlaylist] = useState(false);
  const [activeStep, setActiveStep] = useState(0);
  const [detailPanelRowId, setDetailPanelRowId] = useState(null); // 🆕

  useEffect(() => {
    if (!Array.isArray(data)) {
      setRows([]);
      return;
    }

    const transformedRows = data.map((playlist) => ({
      id: playlist.id,
      name: playlist.name,
      description: playlist.description,
      type: playlist.type,
      status: playlist.status,
      fatality: playlist.fatality,
      ...playlist,
    }));
    setRows(transformedRows);
  }, [data]);

  const handleFilterModelChange = (newFilterModel) => {
    setFilterModel(newFilterModel);
    const validFilters = newFilterModel.items.filter(
      (filter) => filter.value !== undefined && filter.value !== ""
    );
    if (validFilters.length > 0) {
      dispatch(fetchPlaylists({ filters: validFilters, sortModel: [] }));
    }
  };

  const handleSortModelChange = (newSortModel) => {
    setSortModel(newSortModel);
    const validFilters = filterModel.items.filter(
      (filter) => filter.value !== undefined && filter.value !== ""
    );
    dispatch(
      fetchPlaylists({ filters: validFilters, sortModel: newSortModel })
    );
  };

  const handleCloseCreatePlaylist = () => {
    setOpenCreatePlaylist(false);
  };

  const columns = [
    { field: "id", headerName: "ID", flex: 0.5, minWidth: 80 },
    { field: "name", headerName: "Name", flex: 1, minWidth: 250 },
    {
      field: "type",
      headerName: "Type",
      flex: 1,
      minWidth: 170,
      renderCell: (params) =>
        params.value ? params.value.toLowerCase() : "N/A",
    },
    {
      field: "status",
      headerName: "Status",
      flex: 1,
      minWidth: 170,
      renderCell: (params) =>
        params.value ? params.value.toLowerCase() : "N/A",
    },
    {
      field: "isPublic",
      headerName: "Visibility",
      flex: 1,
      minWidth: 170,
      renderCell: (params) => (params.value ? "Public" : "Private"),
    },
    {
      field: "fatality",
      headerName: "Fatality",
      flex: 1,
      minWidth: 170,
      renderCell: (params) => (params.value ? "Yes" : "No"),
    },
    {
      field: "actions",
      headerName: "",
      flex: 1.2,
      minWidth: 200,
      sortable: false,
      filterable: false,
      renderCell: (params) => (
        <PlaylistActionCell
          id={params.row.id}
          row={params.row}
          detailPanelRowId={detailPanelRowId}
          setDetailPanelRowId={setDetailPanelRowId}
        />
      ),
    },
  ];

  return (
    <Box sx={{ height: "100%", width: "100%" }}>
      <DataGridPro
        apiRef={apiRef}
        checkboxSelection
        disableRowSelectionOnClick
        filterModel={filterModel}
        onFilterModelChange={handleFilterModelChange}
        rowSelectionModel={selectionModel}
        onRowSelectionModelChange={(newSelection) =>
          setSelectionModel(newSelection)
        }
        slotProps={{
          filterPanel: {
            sx: {
              backgroundColor: theme.palette.background.paper,
              color: theme.palette.text.primary,
              '& .MuiButton-root': {
                backgroundColor: (theme) => theme.palette.background.button,
                color: (theme) => theme.palette.common.white,
                textTransform: "none",
                px: 2,
                "&:hover": {
                  backgroundColor: (theme) => theme.palette.background.button,
                },
              },
              '& .MuiIconButton-root': {
                color: theme.palette.text.primary,
              },
            }
          },
          columnsPanel: {
            sx: {
              backgroundColor: theme.palette.background.paper,
              color: theme.palette.text.primary,
            },
          },
        }}
        rows={rows}
        columns={columns}
        loading={loading}
        sortingMode="server"
        filterMode="server"
        hideFooter
        onSortModelChange={handleSortModelChange}
        getDetailPanelContent={({ row }) => <DetailPanel row={row} />}
        getDetailPanelHeight={() => "auto"}
        hideDetailPanelToggle={true}
        initialState={{
          columns: {
            columnVisibilityModel: {
              __detail_panel_toggle__: false,
            },
          },
        }}
        sx={{
          width: "100%",
          height: "100%",
        }}
      />
    </Box>
  );
}

export default PlaylistDataGrid;
